import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';

@Component({
  selector: 'withdraw-auto',
  templateUrl: '../sharedTemplates/withdraw-auto.html',
})
export class WithdrawAuto {
  autoLimitModel: number;
  statu = '';
  step = 0; //0 --> No-Activated 1  --> Activated 2 -->  Set Limit 3 -->  Success Process
  autoWithdrawState = false;
  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    public _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper
  ) {}

  ngAfterViewInit() {
    if (this._UiHelper.rightMenu) this._UiHelper.setRightMenu();

    this._UiHelper.setNavbarTitle('Withdraw', true);
    this.autoWithdrawState = Boolean(this._UiHelper.userProfileList?.IsAutoWithdraw);
  }

  confirm_Contract(type: number) {
    if (type === 0) {
      this.autoWithdrawState = false;
    } else {
      this.step = 2;
    }
  }
  auto_Withdraw_Req(type: number) {
    if (type === 0) {
      this.autoWithdrawState = false;
      this.step = 0;
    } else {
      this.setWithdrawReq(true, this.autoLimitModel);
      this.step = 0;
    }
  }

  setWithdrawReq(isActive: boolean, limit: number) {
    if (this._UiHelper.userProfileList.AutoWithdrawMinLimit <= limit) {
      this._ApiService.autoWithdrawReq(isActive, limit).then(result => {
        if (result.Status) {
          this.step = 3;
          this.getCustomerOne();
        }
      });
    }
  }
  toggleAutoWithdraw() {
    this.autoWithdrawState = !this.autoWithdrawState;

    if (!this.autoWithdrawState) {
      this.setWithdrawReq(false, 0);
      this.step = 0;
    } else {
      this.step = 1;
    }
  }
  getCustomerOne() {
    this._ApiService.getCustomerOne().then(CustomerOne => {
      if (CustomerOne && CustomerOne.length > 0) {
        this._UiHelper.userProfileList = CustomerOne[0];
      }
    });
  }
}
